"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOnboardingAssistantPrompt = exports.isOnboardingAssistantStep = void 0;
const util_1 = require("@app/util");
const use_onboarding_steps_1 = require("./use-onboarding-steps");
/**
 * The message sent to the manager assistant — as the MANAGER'S own first turn — when
 * „Vyřešit" is clicked on an onboarding step. One per step, so the conversation opens with
 * the manager asking about the thing they set out to do.
 *
 * The reply is the agent's, and so are any quick-reply buttons under it: the workflow emits
 * a ```suggestions block and `SuggestedReplies` in manager-assistant-chat.tsx renders it.
 * Nothing here writes text in the assistant's voice.
 *
 * Only the steps whose button actually does something are here. REWARD has no link and a
 * disabled button, so it can never be clicked (see `use-onboarding-steps.ts`); it gets a key
 * once it does.
 */
const PROMPT_KEYS = {
    [use_onboarding_steps_1.STEP_KEYS.POSITIONS]: 'ONB_ASSISTANT_POSITIONS',
    [use_onboarding_steps_1.STEP_KEYS.EMPLOYEES]: 'ONB_ASSISTANT_EMPLOYEES',
    [use_onboarding_steps_1.STEP_KEYS.CONTRACTS]: 'ONB_ASSISTANT_CONTRACTS',
    [use_onboarding_steps_1.STEP_KEYS.SCHEDULE]: 'ONB_ASSISTANT_SCHEDULE',
    [use_onboarding_steps_1.STEP_KEYS.PUBLISH]: 'ONB_ASSISTANT_PUBLISH',
    [use_onboarding_steps_1.STEP_KEYS.TERMINAL]: 'ONB_ASSISTANT_TERMINAL',
    [use_onboarding_steps_1.STEP_KEYS.DASHBOARD]: 'ONB_ASSISTANT_DASHBOARD',
};
/**
 * Whether this step opens an assistant thread at all. The step id arrives from the
 * (persisted) store, so it can be anything a past build wrote there.
 */
const isOnboardingAssistantStep = (step) => Object.prototype.hasOwnProperty.call(PROMPT_KEYS, step);
exports.isOnboardingAssistantStep = isOnboardingAssistantStep;
/**
 * The text to send for a step, or null when there is nothing to send — an unknown step, or
 * a key a human hasn't entered in Tolgee yet.
 *
 * The second case is why this returns null rather than a string: `t` is `i18next.t` with no
 * missing-key handler, so an unentered key comes back as the key itself. Sending that would
 * post `ONB_ASSISTANT_POSITIONS` to the agent as the manager's words and get a confused
 * reply. The thread still opens (see the seed effect in manager-assistant-chat.tsx) — it
 * just opens empty.
 */
const buildOnboardingAssistantPrompt = (step) => {
    if (!(0, exports.isOnboardingAssistantStep)(step))
        return null;
    const promptKey = PROMPT_KEYS[step];
    if ((0, util_1.isUndefined)(promptKey))
        return null;
    const text = String((0, util_1.t)(promptKey));
    return text === promptKey ? null : text;
};
exports.buildOnboardingAssistantPrompt = buildOnboardingAssistantPrompt;
